import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "benchmark",
  class: "section-container"
}
const _hoisted_2 = { class: "section-content" }

import { vReveal } from '@/directives/reveal'
import ImagePreview from './ImagePreview.vue'
import fig2Src from '@/assets/picture/New Fig2 LSV benchmark_page.jpg'
import { useSmoothScroll } from '@/composables/useSmoothScroll'


export default /*@__PURE__*/_defineComponent({
  __name: 'BenchmarkSection',
  setup(__props) {

const { scrollToId } = useSmoothScroll()
const scrollToLeaderboard = () => scrollToId('leaderboard')

return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "section-title" }, "LabSuperVision (LSV) Benchmark", -1)),
      _createElementVNode("p", {
        class: "section-lead clickable-text",
        onClick: scrollToLeaderboard
      }, " We are launching LSV in close collaboration with NVIDIA for lab-driven science. We are calling on academic groups to contribute to this exciting ecosystem, where we already have 200+ expert-annotated lab videos with gold-standard protocols for protocol alignment and issue detection. "),
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "section-subtext" }, " To submit your model to the leaderboard please provide your code and paper below. ", -1)),
      _createVNode(_component_a_row, { gutter: [28, 28] }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 24,
            md: 12,
            lg: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_card, { class: "content-card" }, {
                default: _withCtx(() => [
                  _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "card-title" }, "Evaluate Your Model", -1)),
                  _cache[2] || (_cache[2] = _createElementVNode("p", { class: "card-text" }, " We evaluate leading VLMs/agents (e.g., GPT-4o, Gemini 2.5, Cosmos) and support community submissions. ", -1)),
                  false
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToSubmit && _ctx.goToSubmit(...args)))
                      }, " Submit Model / Data "))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 24,
            md: 12,
            lg: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_card, { class: "content-card" }, {
                default: _withCtx(() => [
                  _createVNode(ImagePreview, {
                    src: _unref(fig2Src),
                    alt: "LSV Benchmark illustration"
                  }, null, 8, ["src"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])), [
      [_unref(vReveal)]
    ])
  ]))
}
}

})